import React from 'react';
import { useRestaurant } from '../../../contexts/restaurant.context';

function MenuPaused() {
    const restaurant = useRestaurant();

    return (
        <div>
            {restaurant && restaurant.website_pause_message && (
                <p dangerouslySetInnerHTML={{
                    __html: restaurant.website_pause_message
                }}/>
            )}
            {(!restaurant || !restaurant.website_pause_message) && (
                <div className="alert alert-warning" role="alert">
                    Vendor has paused ordering at the moment.
                </div>
            )}
        </div>
    )
}

export default MenuPaused;